import React, { useState } from "react";

import { Col, Dropdown, MenuProps, Row, Typography } from "antd";
import { toast } from "utils/toast";

import CreditCard from "js/components/Memberships/CreditCard";
import EmptyCard from "js/components/Memberships/EmptyCard";
import { CreditCardItem } from "js/components/Memberships/types";

import {
  useDeleteCard,
  useGetCards,
  useUpdateCard,
} from "../../../hooks/usePayments";
import "../../../styles/components/Memberships/creditCard.scss";

const { Title, Text } = Typography;

const CreditCardSection: React.FC = () => {
  const [selectedCard, setSelectedCard] = useState<CreditCardItem>({
    brand: "",
    created_at: "",
    id: "",
    is_default: false,
    last4: "",
    sessionId: "",
    token: "",
  });

  const { data: cards, isLoading } = useGetCards();
  const deleteCardMutation = useDeleteCard();
  const updateCardMutation = useUpdateCard();

  const brandStyles = {
    visa: "visa",
    mastercard: "mastercard",
    american_express: "american-express",
    carnet: "carnet",
    unknown: "unknown",
  };

  const onClick = ({ key }) => {
    if (key === "2") {
      if (selectedCard.is_default) {
        return toast.error("No es posible eliminar la tarjeta predeterminada");
      }
      deleteCardMutation.mutate(selectedCard.id);
    } else {
      updateCardMutation.mutate(selectedCard.id);
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <Text>Predeterminar</Text>,
    },
    {
      key: "2",
      label: <Text type={"danger"}>Eliminar</Text>,
    },
  ];

  const renderCard = (card: CreditCardItem) => {
    const brand = brandStyles[card.brand] ?? "unknown";
    const maskedCardNumber = `***********${
      brand !== "american-express" ? "*" : ""
    }${card.last4}`;

    return (
      <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={5}>
        <Dropdown menu={{ items, onClick }} trigger={["click"]}>
          <div onClick={() => setSelectedCard(card)}>
            {card.is_default && (
              <div className="default-banner">{"Predeterminada"}</div>
            )}
            <CreditCard
              key={card.id}
              number={maskedCardNumber}
              brand={brand}
              preview={true}
            />
          </div>
        </Dropdown>
      </Col>
    );
  };

  return (
    <>
      <Title level={2}>Tarjetas</Title>
      <Row gutter={[10, 10]} justify={"start"}>
        {cards && cards.length < 3 && (
          <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={5}>
            <EmptyCard />
          </Col>
        )}
        {cards?.map((card) => renderCard(card))}
      </Row>
    </>
  );
};

export default CreditCardSection;
